export const environment = {
  production: true,
  api: 'https://devservices.sequation.net',
  enableCtrl: false,
  azureBlobStorage: 'https://sequation-dev-cdn-v2.sequation.net'
};